import { FC, useEffect } from 'react';

import { OrganisationSwitcher } from '@britishcouncil/react-registration-platform';

import styled from '@emotion/styled';
import { useRouter } from '../../../../hooks/useRouter';

import { flatOrganisations, useAppSelector, commonAPI, store } from '@/store';
import { useOrganisationContext } from '@/utils/context/OrganisationContext';
import { BCLogo } from '@/components';

export const OrganisationSwitcherWrapper: FC = () => {
  const router = useRouter();
  const { setOrgData } = useOrganisationContext();
  const organisation = useAppSelector((s) => s.organisation);
  const { data: permissions, isFetching, isError, isSuccess } = commonAPI.usePermissionsGetPermissionTreeQuery();
  const organisationsWithAccess = flatOrganisations(permissions?.children ?? []).filter((org) => org.hasAccess);

  const hasOrganisations = organisationsWithAccess.length !== 0;
  const hasAccessToCurrentOrganisation = organisation.id ? organisationsWithAccess.some((el) => el.id === organisation.id) : true;

  useEffect(() => {
    if (isSuccess && (!hasOrganisations || !hasAccessToCurrentOrganisation)) {
      !hasOrganisations && router.push('/organisation/error');
    }
  }, [hasAccessToCurrentOrganisation, hasOrganisations, isSuccess, permissions, router]);

  const handleOrganisationChange = (organisation: { id?: string; name?: string }) => {
    setOrgData(organisation)
    store.dispatch(commonAPI.util.invalidateTags(['OrganisationPermissions']));
    router.push('/');
  };

  return (
    <OrganisationAndLogoWrapper>
      <LogoWrapper>
        <img src={BCLogo} alt="British Council Logo" />
      </LogoWrapper>
      <ListContainer>
        <OrganisationSwitcher
          isError={isError}
          isLoading={isFetching}
          isSuccess={isSuccess}
          organisation={organisation}
          permissions={permissions?.children?.[0]}
          onChange={handleOrganisationChange}
        />
      </ListContainer>
    </OrganisationAndLogoWrapper>
  );
};

const ListContainer = styled.div`
  align-self: center;
  h5 {
    margin: 0;
  }
`;

const OrganisationAndLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const LogoWrapper = styled.div`
  margin-right: 24px;
`;
